import styled from '@emotion/styled';

export const Container = styled.a`
  color: ${({theme}) => theme.colors.contentPrimary};
  text-decoration: none;
`;
